import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SecurityService } from '../services/security/security.service';

export const httpInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const securityService = inject(SecurityService);
  
  const token = securityService.getToken();
  let authReq = req;

  // Preparar todos los headers necesarios en un solo objeto
  const headersToSet: { [key: string]: string } = {};

  // Agregar token si existe
  if (token && !securityService.isTokenExpired()) {
    headersToSet['Authorization'] = `Bearer ${token}`;
  }
  
  // No agregar Content-Type si el body es FormData (para permitir multipart/form-data)
  const isFormData = req.body instanceof FormData;
  
  // Agregar Content-Type solo si no está ya presente y no es FormData
  if (!authReq.headers.has('Content-Type') && !isFormData) {
    headersToSet['Content-Type'] = 'application/json';
  }
  
  // Agregar Accept solo si no está ya presente
  // Para listados (GET con parámetros de paginación), usar application/ld+json para formato Hydra de API Platform
  if (!authReq.headers.has('Accept')) {
    const isGetRequest = req.method === 'GET';
    const url = req.url.toLowerCase();
    const hasPaginationDisabled = url.includes('pagination=false');
    const hasPaginationParams = url.includes('page=') || 
                                url.includes('size=') || 
                                url.includes('itemspage=');
    
    // Si es un GET con parámetros de paginación (pero NO con pagination=false), 
    // usar application/ld+json para formato Hydra
    // Si pagination=false, usar application/json (devuelve array simple)
    // De lo contrario, usar application/json por defecto
    if (isGetRequest && hasPaginationParams && !hasPaginationDisabled) {
      headersToSet['Accept'] = 'application/ld+json';
    } else {
      headersToSet['Accept'] = 'application/json';
    }
  }

  // Hacer un solo clone con todos los headers necesarios
  if (Object.keys(headersToSet).length > 0) {
    authReq = req.clone({ setHeaders: headersToSet });
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      let errorMessage = '';

      if (error.error instanceof ErrorEvent) {
        // Error del lado del cliente
        errorMessage = `Error: ${error.error.message}`;
        console.error('Error del cliente:', errorMessage);
      } else {
        // Error del lado del servidor
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        console.error('Error del servidor:', errorMessage);

        // Manejar errores específicos
        switch (error.status) {
          case 401:
            // Token inválido o expirado
            console.error('Token inválido o expirado. Redirigiendo a login...');
            securityService.logout();
            router.navigate(['/auth/login']);
            break;
          case 403:
            // Sin permisos
            console.error('Acceso denegado: sin permisos suficientes');
            router.navigate(['/auth/accessdenied']);
            break;
          case 404:
            console.error('Recurso no encontrado');
            break;
          case 500:
            console.error('Error interno del servidor');
            break;
          default:
            console.error('Error no manejado:', error);
        }
      }

      return throwError(() => error);
    })
  );
};

